import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import List from "../Components/Orders/List";
import Add from "../Components/Orders/Add";
import View from "../Components/Orders/View";
import History from "../Components/Orders/History";
import { useLocation } from "react-router-dom";
import Pi from "../Components/Orders/Pi";
import PiView from "../Components/Orders/PiView";
import PiEdit from "../Components/Orders/PiEdit";
import PreChallan from "../Components/Orders/PreChallan";
import MarketingChallan from "../Components/Orders/MarketingChallan";
import LogisticLoadingForm from "../Components/Orders/LogisticLoadingForm";
import LogisticLoadingView from "../Components/Orders/LogisticLoadingView";
import AllViews from "../Components/Orders/AllViews";
import PostChallan from "../Components/Orders/PostChallan";
import CreateInvoice from "../Components/Orders/CreateInvoice";
import AllChallans from "../Components/Orders/AllChallans";
import ViewInvoice from "../Components/Orders/ViewInvoice";

function Orders() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Sales Orders</h1>
          </div>

          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "view" ? ( // Check if comp is "scan"
              // <AllViews comp={comp} rowData={rowData} onChange={handleChange} />
            <View comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "PiView" ? ( // Check if comp is "scan"
            <PiView comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "PreChallan" ? ( // Check if comp is "scan"
            <PreChallan comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "post-challan" ? ( // Check if comp is "scan"
              <PostChallan comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "MarketingChallan" ? ( // Check if comp is "scan"
            <MarketingChallan
              comp={comp}
              rowData={rowData}
              onChange={handleChange}
            />
          ) : comp === "history" ? ( // Check if comp is "scan"
            <History comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "pi" ? ( // Check if comp is "scan"
            <Pi comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "editPi" ? ( // Check if comp is "scan"
            <PiEdit comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "logistic-loading" ? (
            <LogisticLoadingView
              comp={comp}
              rowData={rowData}
              onChange={handleChange}
            />
          ) : comp === "logistic-loading-form" ? ( // Check if comp is "scan"
              <LogisticLoadingForm comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "create-invoice" ? (
              <CreateInvoice comp={comp} rowData={rowData} onChange={handleChange} />
          ): comp === "view-invoice" ? (
              <ViewInvoice comp={comp} rowData={rowData} onChange={handleChange} />
          )  : comp === "challans" ? (
              <AllChallans comp={comp} rowData={rowData} onChange={handleChange} />
          )  : (
            <Add comp={comp} rowData={rowData} onChange={handleChange} />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default Orders;
